// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__pfJ9N","Title":"Header_Title__P4FOe","SideButtonContainer":"Header_SideButtonContainer__aRDyK"};